let lastScrollY = 0;
export const fixedHeader = () => {
    const header = document.querySelector('.site-header');
    const operationType = header && Math.floor(window.scrollY) > 0 ? 'add' : 'remove';
    header.classList[operationType]('sticky');

    const currentScrollY = window.scrollY;

    if (currentScrollY === 0) {
        // Remove the visible class when at the top of the page
        header.classList.remove('visible');
    } else if (currentScrollY < lastScrollY) {
        // Scrolling up: show the header
        header.classList.add('visible');
    } else {
        // Scrolling down: hide the header
        header.classList.remove('visible');
    }

    // Update the last scroll position
    lastScrollY = currentScrollY;
}

export const mainMenu = () => {
    const button = document.querySelector('.js-mobile-menu-toggle');
    const header = document.querySelector('.js-site-header');
    const mainMenu = document.querySelector('.js-main-menu');
    button && button.addEventListener( 'click', (e) => {
        if (e.target.classList.contains('active')) {
            e.target.classList.remove('active');
            document.body.classList.remove('menu-opened');
            header.classList.remove('menu-opened');
            mainMenu.classList.remove('active');
        } else {
            document.body.classList.add('menu-opened');
            header.classList.add('menu-opened');
            mainMenu.classList.add('active');
            e.target.classList.add('active');
        }
      
    } );
}

/**
 * Checks if an element is within the viewport, considering an optional offset.
 *
 * @param {Element} element - The DOM element to check.
 * @param {number} offset - The offset to apply to the element's position.
 * @returns {boolean} - Returns true if the element is within the viewport, false otherwise.
 */
export const inViewport = (element, offset) => {
    // Get the current vertical scroll position
    let scroll = window.scrollY;

    // Calculate the top and bottom of the element's scope, including the offset
    let scope_top = element.getBoundingClientRect().top + scroll + offset;
    let scope_bottom = scope_top + element.clientHeight;

    // Define the top and bottom of the viewport
    let viewport_top = scroll;
    let viewport_bottom = window.innerHeight + scroll;

    // Check if the element is within the viewport
    return (
        (scope_bottom >= viewport_top && scope_bottom <= viewport_bottom) ||
        (scope_top <= viewport_bottom && scope_top >= viewport_top)
    );
};

/**
 * Checks if an element's center is within the middle of the viewport.
 * 
 * @param {Element} element - The DOM element to check.
 * @return {boolean} - True if the element's center is in the middle of the viewport, otherwise false.
 */
export const isInMiddleOfScreen = (element) => {
    const rect = element.getBoundingClientRect();
    const elementCenter = rect.top + rect.height / 2;
    const viewportCenter = (window.innerHeight || document.documentElement.clientHeight) / 2;

    // Check if the element's center is within the height of the element around the viewport center
    return (
        elementCenter >= viewportCenter - rect.height / 2 &&
        elementCenter <= viewportCenter + rect.height / 2
    );
};

/**
 * Initializes the accordion.
 */
export const initAccordion = () => {
    // Select all elements with class 'js-accordion-click'
    const accordionButton = document.querySelectorAll('.js-accordion-button');
    accordionButton &&
        accordionButton.forEach((item) => {
            item.addEventListener('click', () => {
                const accordionParent = item.closest('.js-accordion-parent');
                const accordionItem = item.closest('.js-accordion-item');
                
                if (accordionItem?.classList.contains('active')) {
                accordionItem?.classList.remove('active');
                } else {
                const headerHeight = document.querySelector('.site-header').offsetHeight;
                const activeAccordion = accordionParent?.querySelector( '.js-accordion-item.active' );
                activeAccordion?.classList.remove('active');
                accordionItem?.classList.add('active');
                }
            });
        });
};

/**
 * Adds click event listeners to elements with the 'scroll-to' class.
 * On click, reads the 'rel' attribute value and scrolls to the section
 * with the corresponding 'id', adjusting for the height of a fixed header.
 */
export const setupScrollTo = () => {
    // Select all elements with the 'scroll-to' class
    const links = document.querySelectorAll('.scroll-to > a');
    // Get the height of the fixed header
    const headerHeight = document.querySelector('.site-header').offsetHeight;

    // Get mobile menu button
    const mobileBtn = document.querySelector('.js-mobile-menu-toggle');

    // Track the last scroll position
    let lastScrollPosition = window.scrollY;

    // Check if links exist and attach click event listeners
    if (links) {
        links.forEach((link) => {
            link.addEventListener('click', (event) => {
                event.preventDefault(); // Prevent the default link behavior

                // Close mobile menu if it's opened
                if (mobileBtn.classList.contains('active')) {
                    mobileBtn.click();
                }

                // Get the value of the 'rel' attribute
                const targetId = link.getAttribute('rel');
                // Select the target section by the 'id' matching the 'rel' attribute
                const targetElement = document.getElementById(targetId);
                if (targetElement) {
                    // Determine the scroll direction
                    const currentScrollPosition = window.scrollY;
                    const isScrollingUp = currentScrollPosition > targetElement.offsetTop;

                    // Adjust the offset dynamically
                    const offset = isScrollingUp ? headerHeight : 0;

                    // Calculate the position to scroll to, accounting for the dynamic offset
                    const targetPosition = targetElement.offsetTop - offset;

                    // Smooth scroll to the target position
                    window.scrollTo({
                        top: targetPosition,
                        behavior: 'smooth',
                    });

                    // Update the last scroll position
                    lastScrollPosition = currentScrollPosition;
                } else {
                    // Redirect to the homepage with a query parameter for the target section
                    window.location.href = `/?section=${targetId}`;
                }
            });
        });
    }
};

/**
 * Checks if there's a query parameter for section scroll and scrolls to that section
 * after the page loads.
 */
export const handleSectionScrollFromQuery = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const targetId = urlParams.get('section');
    const targetBlock = urlParams.get('block');

    if (targetId) {
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
            const headerHeight = document.querySelector('header').offsetHeight;
            
            setTimeout(() => { 
            const targetPosition = targetElement.offsetTop;
            
            window.scrollTo({
                top: targetPosition,
                behavior: 'smooth'
            });
            }, 200);
        }
    }

    if (targetBlock) {
        const targetElement = document.getElementById(targetBlock);
        if (targetElement) {
            // Get the element's top position relative to the document
            const elementTop = targetElement.getBoundingClientRect().top + window.scrollY;

            // Get the viewport height
            const viewportHeight = window.innerHeight;

            // Calculate the target position
            const targetPosition = elementTop - (viewportHeight / 2) + (targetElement.offsetHeight / 2);

            window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
            });
        }
    }

};

/**
 * Initializes Userway.
 */
let userwayInitialized = false;
export const initializeUserway = () => {
    if (userwayInitialized) {
        return;
    }
    const s = document.createElement('script');
    s.setAttribute('data-language', 'en');
    s.setAttribute('data-account', 'LCo6MCQIvl');
    s.defer = true;
    s.setAttribute('src', 'https://cdn.userway.org/widget.js');
    (document.body || document.head).appendChild(s);
    userwayInitialized = true;
};

/**
 * Adds a click event listener to the button with the class `js-scroll-top`.
 * When clicked, the page smoothly scrolls to the top.
 */
export const addScrollToTopEvent = () => {
  const scrollTopButton = document.querySelector('.js-scroll-top');
  
  if (!scrollTopButton) return; // Return if the button doesn't exist

  scrollTopButton.addEventListener('click', (event) => {
        event.preventDefault(); // Prevent any default action (e.g., link navigation)

        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
  });
};

export const initTextFillAnimation = () => {
    let paragraph = document.querySelectorAll('.js-text-fill');

    if(!paragraph) {
        return;
    }

    paragraph = new SplitType (paragraph, {types: 'lines'});

    gsap.config({ trialWarn: false });
    gsap.registerPlugin(ScrollTrigger);

    paragraph.lines.forEach((target) => {
        gsap.to(target, {
            backgroundPositionX: 0,
            ease: "none",
            scrollTrigger: {
            trigger: target,
            markers: false,
            scrub: 1,
            start: "top center",
            end: "bottom center"
            }
        });
    });
}

/**
 * Sets the minimum height of all elements with the specified class name
 * to the height of the tallest element among them.
 * 
 * @param {string} className - The class name of elements to equalize height for.
 */
export const setEqualHeight = (className) => {
    // Select all elements with the specified class name
    const elements = document.querySelectorAll(`.${className}`);

    // Check if there are any elements with the specified class
    if (elements.length === 0) return; // Exit if no elements are found

    // Find the maximum height among the elements
    let maxHeight = 0;
    elements.forEach(element => {
        const elementHeight = element.offsetHeight;
        if (elementHeight > maxHeight) {
            maxHeight = elementHeight;
        }
    });

    // Set each element's min-height to the maximum height found
    elements.forEach(element => {
        element.style.minHeight = `${maxHeight}px`;
    });
};

export const imageAnimation = () => {
    const images = document.querySelectorAll('.image-animation');

    // Check if there are any elements with the specified class
    if (images.length === 0) return; // Exit if no elements are found

    images.forEach( item => {
        if (inViewport(item, 300)) {
            item.classList.add('active');
        }
    });
}

export const textAnimation = () => {
    const textAnimations = document.querySelectorAll('.text-animation-container');

    // Check if there are any elements with the specified class
    if (textAnimations.length === 0) return; // Exit if no elements are found

    textAnimations.forEach( item => {
        if (inViewport(item, 200)) {
            item.classList.add('active');
        }
    });
}

/**
 * Binds click events to all `.js-anchor-link` elements.
 */
export const anchorLinkHandler = () => {
    const links = document.querySelectorAll('.js-anchor-link');
  
    links && links.forEach((link) => {
        link.addEventListener('click', (event) => {
            const href = link.getAttribute('href');
            const isAnchor = href.startsWith('#');
            const sectionId = href.split('#')[1]; // Extracts the part after '#'
            const targetElement = sectionId ? document.getElementById(sectionId) : null;
    
            if (isAnchor && targetElement) {
                event.preventDefault(); // Prevent default link behavior
        
                // Scroll to the section smoothly
                targetElement.scrollIntoView({ behavior: 'smooth' });
            } else {
                // Proceed with default link behavior (if it's not a section anchor)
                window.location.href = href;
            }
        });
    });
};

/**
 * Updates input fields within elements having the class .js-discount.
 */

export const updateDiscountInputs = () => {
    const discountButtons = document.querySelectorAll('.js-discount-btn');

    discountButtons && discountButtons.forEach(button => {
        button.addEventListener('click', () => {
            const input = document.querySelector('.js-discount');
            
            if (input) {                
                input.setAttribute('value', 'YES');
            }
        });
    });
}